import UploadBill from "./UploadBill/uploadBill";
import VendorList from "./VendorList/VendorList";
import VendorBills from "./VendorBills/VendorBills";
import VendorRegister from "./VendorRegister/VendorRegister";

export {UploadBill,VendorList,VendorBills,VendorRegister}